import { api } from "@/api";

import { QueryProps } from "@/types/Api";
import { FeedType, SportEvent } from "@/types/SportsApiResponses";
import {
  DEFAULT_VIRTUAL_SPORT_TYPE,
  VirtualSportType,
} from "./virtualSportType";

// Virtual sports (Sportradar VFL / VBL) hit the SAME sport-events endpoint, but
// through this dedicated function so the shared `getSportEventsNew` stays
// football/basketball only — no `if VR` branch anywhere in the generic API.

export interface GetVirtualSportEventsParams {
  feedType: FeedType;
  lang: string;
  page?: number;
  pageSize?: number;
  minOffset?: string | number;
  // Specific betting week (absolute round) — VR line feed only.
  round?: number;
  // Which virtual sport to list; defaults to virtual football.
  sportType?: VirtualSportType;
  // Ask for each event's cached "N odds" badge count (Zero VR bülten only).
  withOddsCount?: boolean;
}

export const getVirtualSportEvents = async (
  props: QueryProps<GetVirtualSportEventsParams>
): Promise<SportEvent[]> => {
  const { sportType = DEFAULT_VIRTUAL_SPORT_TYPE, ...params } = props.params;
  const res = await api.client.get("/sport-events-new", {
    signal: props.signal,
    params: { ...params, sportType },
  });
  return res.data.items;
};
